import { MessageCircle } from "lucide-react";
import { Button } from "../components/ui/button";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

const WHATSAPP_NUMBER = "56929894282";
const WHATSAPP_MESSAGE = encodeURIComponent("Hola Odontofix, tengo una consulta urgente.");
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`;

const faqs = [
  {
    question: "¿Qué incluye una mantención preventiva?",
    answer: "Una mantención preventiva incluye inspección completa del equipo, calibración básica, limpieza técnica según tipo de equipo, verificación de seguridad y checklist de mantención. Entregamos informe detallado con recomendaciones y registro en historial."
  },
  {
    question: "¿Cada cuánto recomiendan hacer preventivo?",
    answer: "Depende del equipo y su uso. En general, recomendamos mantenciones preventivas cada 6 a 12 meses para equipos de uso frecuente. Durante la evaluación inicial definimos la frecuencia óptima según tu caso."
  },
  {
    question: "¿Cómo cotizan una correctiva?",
    answer: "Realizamos un diagnóstico inicial para identificar la falla. Luego entregamos un presupuesto detallado con el trabajo a realizar y los repuestos necesarios (si aplica). Solo procedemos con tu aprobación."
  },
  {
    question: "¿Trabajan con repuestos originales y alternativos?",
    answer: "Sí, trabajamos con ambos tipos de repuestos. Siempre informamos las opciones disponibles con sus diferencias de precio y garantía para que puedas decidir lo mejor para tu caso."
  },
  {
    question: "¿Entregan informe o registro del trabajo?",
    answer: "Sí, cada intervención (preventiva o correctiva) incluye un informe detallado con el trabajo realizado, observaciones, recomendaciones y evidencia fotográfica cuando corresponde. Todo queda registrado en el historial del equipo."
  },
  {
    question: "¿Atienden fuera de Santiago?",
    answer: "Sí, atendemos en regiones según coordinación previa. Escríbenos indicando tu ubicación y tipo de equipo para evaluar la factibilidad y coordinar la visita."
  },
  {
    question: "¿Cómo funciona la app gratuita?",
    answer: "La app te permite registrar tus equipos, ver el historial de mantenciones, crear tickets de servicio y recibir alertas de preventivos. Es gratuita para clientes Odontofix. Solo debes solicitarnos el acceso."
  },
  {
    question: "¿Puedo llevar historial por equipo?",
    answer: "Sí, cada equipo tiene su ficha individual con todo el historial de intervenciones, informes y documentos. Puedes acceder a esta información desde la app o solicitarnos reportes específicos."
  },
  {
    question: "¿Qué información debo enviar para cotizar más rápido?",
    answer: "Para agilizar la cotización, incluye: tipo de equipo, marca y modelo (si lo tienes), descripción del problema o servicio requerido, y datos de contacto. Fotos del equipo o del problema también ayudan."
  },
  {
    question: "¿Cómo agendo una visita?",
    answer: "Puedes agendar una visita escribiéndonos por WhatsApp o correo, o completando el formulario de contacto. Te responderemos para coordinar fecha y horario según tu disponibilidad."
  }
];

export default function FAQ() {
  return (
    <div data-testid="faq-page">
      {/* Hero Section */}
      <section className="bg-secondary py-16 md:py-20" data-testid="faq-hero">
        <div className="container mx-auto px-4 md:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="font-heading text-4xl md:text-5xl font-bold text-white mb-6">
              Preguntas Frecuentes
            </h1>
            <p className="text-xl text-white/90 leading-relaxed">
              Resolvemos tus dudas sobre mantención de equipos clínicos
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 md:py-24 bg-white" data-testid="faq-content">
        <div className="container mx-auto px-4 md:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto">
            <Accordion type="single" collapsible className="space-y-4">
              {faqs.map((faq, index) => (
                <AccordionItem 
                  key={index} 
                  value={`item-${index}`}
                  className="bg-background rounded-xl border-0 px-6 data-[state=open]:shadow-md transition-shadow"
                  data-testid={`faq-item-${index}`}
                >
                  <AccordionTrigger className="text-left font-heading font-semibold text-text-primary hover:text-primary hover:no-underline py-6">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-text-secondary pb-6 leading-relaxed">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-20 bg-[#0FB4B7]" data-testid="faq-cta">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 text-center">
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-white mb-6">
            ¿Tienes una urgencia?
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Escríbenos por WhatsApp y te atenderemos lo antes posible
          </p>
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
            <Button 
              size="lg" 
              className="bg-whatsapp hover:bg-whatsapp/90 text-white h-14 px-8 text-lg"
              data-testid="faq-cta-whatsapp"
            >
              <MessageCircle className="h-5 w-5 mr-2" />
              Escribir por WhatsApp
            </Button>
          </a>
        </div>
      </section>
    </div>
  );
}
